<template>
  <v-form ref="form" method="post" autocomplete="on" v-model="validModel" @submit.prevent="handleSubmit">
    <v-card-text class="text-center">
      <div class="text-center font-weight-light"></div>

      <!-- Username field to help password managers -->
      <v-text-field
        :value="usernameField"
        outlined
        autocomplete="username"
        name="username"
        type="text"
        :label="$t('signin.email')"
        readonly
        class="mb-4"
      />

      <!-- Current password field - required by most browsers to trigger password update -->
      <v-text-field
        v-if="requireCurrentPassword"
        outlined
        v-model="currentPasswordModel"
        autocomplete="current-password"
        name="current-password"
        color="secondary"
        type="password"
        :label="$t('signin.current.password')"
        :rules="currentPasswordRules"
        class="mb-4"
      />

      <v-text-field
        outlined
        id="new-password"
        v-model="password1Model"
        autocomplete="new-password"
        name="new-password"
        color="secondary"
        type="password"
        :label="$t('signin.new.password')"
        :rules="password1Rules"
        @focus="disableAutofill"
      />

      <v-text-field
        outlined
        class="mb-8"
        color="secondary"
        v-model="password2Model"
        :label="$t('signin.new.password.confirm')"
        autocomplete="new-password"
        name="new-password-confirm"
        type="password"
        :rules="password2Rules"
        @focus="disableAutofill"
      />

      <v-btn color="accent" rounded large type="submit" :disabled="!validModel">
        {{ $t("signin.change.your.password") }}
      </v-btn>
    </v-card-text>
  </v-form>
</template>

<script>
export default {
  name: 'PasswordForm',
  props: {
    valid: {
      type: Boolean,
      default: true
    },
    newPassword1: {
      type: String,
      default: null
    },
    newPassword2: {
      type: String,
      default: null
    },
    username: {
      type: String,
      default: 'admin'
    },
    requireCurrentPassword: {
      type: Boolean,
      default: false
    },
    currentPassword: {
      type: String,
      default: null
    }
  },
  computed: {
    validModel: {
      get() {
        return this.valid
      },
      set(val) {
        this.$emit('update:valid', val)
      }
    },
    password1Model: {
      get() {
        return this.newPassword1
      },
      set(val) {
        this.$emit('update:newPassword1', val)
      }
    },
    password2Model: {
      get() {
        return this.newPassword2
      },
      set(val) {
        this.$emit('update:newPassword2', val)
      }
    },
    currentPasswordModel: {
      get() {
        return this.currentPassword
      },
      set(val) {
        this.$emit('update:currentPassword', val)
      }
    },
    usernameField() {
      return this.username
    },
    currentPasswordRules() {
      if (!this.requireCurrentPassword) return []
      return [
        v => !!v || 'Obecne hasło jest wymagane'
      ]
    },
    password1Rules() {
      return [
        v => !!v || 'Nowe hasło jest wymagane',
        v => (v && v.length >= 8) || 'Hasło musi mieć minimum 8 znaków'
      ]
    },
    password2Rules() {
      return [
        v => !!v || 'Potwierdzenie hasła jest wymagane',
        v => v === this.newPassword1 || 'Hasła muszą być identyczne'
      ]
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    handleSubmit() {
      this.$emit('submit')
    },
    disableAutofill(event) {
      // Temporarily disable autocomplete when user starts typing
      event.target.setAttribute('autocomplete', 'off')
      // Re-enable after a short delay to allow password manager to save
      setTimeout(() => {
        event.target.setAttribute('autocomplete', 'new-password')
      }, 100)
    }
  }
}
</script>
